<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos" 
    [typeFilter]="Filters.PERIOD"
    [click]="true"
    (eventClick)="cambioPeriodo($event)">
  </app-filters> 
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zonaIzquierda">
      <!-- ========== ZONA SUPERIOR - GRÁFICA 1 (Cartera) ========== -->
      <div class="zonaSup"  id="grafContPrin">
        <div class="headers w3-titulo-contenidomenuSC">
          <div class="w3-half">
            <span class="w3-margin-left-contenido">{{'liquidez.mayores.tituloTabla'| translate }}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
          </div>
          <div class="w3-rest w3-right ">
            @if (!tabMayPrin) {
              <mat-icon fontSet="material-icons-outlined" class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
              (click)="etiquetas1 = !etiquetas1" matTooltip="{{'graf.desactivar'|translate}}">
                {{etiquetas1 ? 'label_off' : 'label'}}
              </mat-icon>              
              <mat-icon class="w3-button w3-dropdown-click iconoMen margenDer" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf('prin')">
                zoom_out_map
              </mat-icon>
            }
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGraficaPrin">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
              </button>
              @if (!tabMayPrin) {
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="graficaCartera(tipoGraf2, true)">
                  <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                  <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                </button>
                <mat-divider/>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica1()">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              } @else {
                <mat-divider/>
                <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportCartera()">
                  <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button>
              }
            </mat-menu>
            <mat-menu #tipoGraficaPrin="matMenu"> 
              <button class="mat-menu-item w3-caja-menu" [ngClass]="{'w3-disabled': tipoGraf2 === 'bar'}" [disabled]="tipoGraf2 === 'bar'" mat-menu-item (click)="graficaCartera('bar', false)">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'liquidez.mayores.tipo3'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" [ngClass]="{'w3-disabled': tipoGraf2 === 'area'}" [disabled]="tipoGraf2 === 'area'" mat-menu-item (click)="graficaCartera('area', false)">
                <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'liquidez.mayores.tipo4'|translate}}</span>
              </button>
              <button class="mat-menu-item w3-caja-menu" [ngClass]="{'w3-disabled': tipoGraf2 === 'line'}" [disabled]="tipoGraf2 === 'line'" mat-menu-item (click)="graficaCartera('line', false)">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'liquidez.mayores.tipo5'|translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        @if (tabMayPrin) {
          <div class="tabla w3-scroll">
            <table class="w3-table borderInf">
              <thead>
                <tr class="w3-center">
                  <th class="stikyColumBlanco"></th>
                  <th class="stikyColumBlanco"></th>
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" colspan="2">{{'liquidez.mayores.tit1'| translate }}</th>
                  <th class="w3-table-titleLow stikyColumCon" colspan="3">{{'liquidez.mayores.tit2'| translate }}</th>
                </tr>
                <tr class="w3-table-title alinCenter" style="line-height: 1.2;">
                  <th class="stikyColumCon2 w3-border-right-balance" >{{'liquidez.mayores.enc1' | translate}}</th>
                  <th class="stikyColumCon2 w3-border-right-balance" >{{'liquidez.mayores.enc2' | translate}}</th>
                  <th class="stikyColumCon2 w3-border-right-balance" style="padding-right: 10px;">
                    {{'liquidez.mayores.enc5' | translate}}
                    <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}" matTooltip="{{'credito.concentracion.info' | translate}}">info</mat-icon>
                  </th>
                  <th class="stikyColumCon2 w3-border-right-balance">{{'liquidez.mayores.enc6' | translate}}</th>
                  <th class="stikyColumCon2 w3-border-right-balance">{{'liquidez.mayores.enc8' | translate}}</th>
                  <th class="stikyColumCon2">{{'liquidez.mayores.enc9' | translate}}</th>
                </tr>
              </thead>
              @for (i of datos; track i.descripcion; let pos = $index) {
                <tr class="w3-table-trtd" style="width: 150px;">
                  <td class="borderAllLow">
                    <span>{{i.descripcion}}</span>
                  </td>
                  <td class="alinRight borderAllLow marginDer"  style="width: 100px;">
                    <span>{{formatoNum(i.saldo, false)}}</span>
                  </td>
                  <td class="alinRight borderAllLow" style="padding-right: 10px;">
                    <span>{{formatoNum(i.total, false)}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{formatoNum(((i.porcen*100).toFixed(1)), true)}}%</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <div matTooltip="Editar" class="inputSpan" (dblclick)="actualizarLimits(i, 'max')">
                      <span>{{formatoNum(obtLimitO(i,'max') , true)}}%</span>
                      <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                    </div>
                  </td>
                  <td class="alinCenter borderAllLow">
                    @if (enRango(i) == 'check_circle') {
                      <mat-icon class="iconoMen"  matTooltip="Cumple los límites" [ngStyle]="{'color':'#8bc34a'}">{{enRango(i)}}</mat-icon>
                    }@else if (enRango(i) == 'cancel') {
                        <mat-icon class="iconoMen" matTooltip="No cumple los límites" [ngStyle]="{'color':'red'}">{{enRango(i)}}</mat-icon>
                    }@else if (enRango(i) == 'help') {
                        <mat-icon class="iconoMen" matTooltip="No hay límites o son incongruentes" [ngStyle]="{'color':'#00B0F0'}">{{enRango(i)}}</mat-icon>
                    }
                  </td>
                </tr>
              }
            </table>
          </div>
        }@else {
          <div class="graficaP">
            @if (dataGrafica1.length > 0 && labelsGrafica1.length > 0) {
              <app-graficador
                #graficador1
                [data]="dataGrafica1"
                [labels]="labelsGrafica1"
                [type]="tipoGrafica1"
                [colors]="colorMono"
                [axisY]="ejesYGrafica1"
                [axisX]="''"
                [zona]="1"
                [etiquetas]="etiquetas1"
                [legend]="{enabled: false, position: 'bottom'}">
              </app-graficador>
            }
          </div>
        }
      </div>  
      <!-- ========== ZONA INFERIOR - TARJETAS ========== -->
      <div class="zonaInf">
        <div class="zonaTarj">
          <!-- TARJETA 1: Proporción Variables -->
          <div class="tarjeta" id="grafContPV" style="width: 47%;">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-setenta">
                <span class="w3-margin-left-contenido">{{'liquidez.mayores.titulotab1'| translate }}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right ">
                @if (!tabMayPV) {
                  <mat-icon fontSet="material-icons-outlined" class="w3-button iconoMen margenDer" [ngStyle]="{'color':'gray'}" 
                  (click)="etiquetas3= !etiquetas3" matTooltip="{{'graf.desactivar'|translate}}">
                    {{etiquetas3 ? 'label_off' : 'label'}}
                  </mat-icon>
                  <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                    (click)="ampliarGraf('pv')">
                    zoom_out_map
                  </mat-icon>
                }
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuTabla2">
                  more_vert
                </mat-icon>
                <mat-menu #menuTabla2="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGraficaPV" >
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
                  </button>
                  @if (!tabMayPV) {
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="graficaProp('', true)">
                      <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                      <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
                    </button>
                    <mat-divider/>
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica3()">
                      <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  } @else {
                    <mat-divider/>
                    <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportPV()">
                      <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                      <span>{{'menu.Exportar' | translate}}</span>
                    </button>
                  }
                </mat-menu>
                <mat-menu #tipoGraficaPV="matMenu"> 
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'bar'}" [disabled]="tipoGraf3 === 'bar'" (click)="graficaProp('bar', false)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'liquidez.mayores.tipo3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'area'}" [disabled]="tipoGraf3 === 'area'" (click)="graficaProp('area', false)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'liquidez.mayores.tipo4'|translate}}</span>
                  </button>
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'line'}" [disabled]="tipoGraf3 === 'line'" (click)="graficaProp('line', false)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'liquidez.mayores.tipo5'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            @if (tabMayPV) {
              <div class="tabla2 w3-scroll">
                <table class="w3-table borderInf">
                  <thead>
                    <tr class="w3-center">
                      <th class="stikyColumBlanco"></th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="line-height: 1.2;">{{'liquidez.mayores.enc10'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="line-height: 1.2;">{{'liquidez.mayores.enc11'| translate }}</th>
                    </tr>
                    <tr class="w3-center w3-table-title">
                      <th class="stikyColumCon2 alinLeft w3-border-right-balance">{{'liquidez.mayores.enc1' | translate}}</th>
                      <th class="stikyColumCon2 alinCenter w3-border-right-balance" style="font-weight: normal; font-size: 8pt;">{{formatoNum(encPropVar[0], false)}}</th>
                      <th class="stikyColumCon2 alinCenter w3-border-right-balance" style="font-weight: normal; font-size: 8pt;">{{formatoNum(encPropVar[1], false)}}</th>
                    </tr>
                  </thead>
                  @for (i of dataPropVar; track i.descripcion) {
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        <span>{{i.descripcion}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum((i.captaciones*100).toFixed(1), true)}}%</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum((i.activos*100).toFixed(1), true)}}%</span>
                      </td>
                    </tr>
                  }
                </table>
              </div>
            }@else {
              <div class="graficaPV">
                @if (dataGrafica3.length > 0 && labelsGrafica3.length > 0) {
                  <app-graficador
                    #graficador3
                    [data]="dataGrafica3"
                    [labels]="labelsGrafica3"
                    [type]="tipoGrafica3"
                    [colors]="colorMulti"
                    [axisY]="ejesYGrafica3"
                    [axisX]="''"
                    [zona]="3"
                    [etiquetas]="etiquetas3"
                    [legend]="{enabled: true, position: 'bottom'}"
                    [altoEtiquetasX]="100">
                  </app-graficador>
                }@else {<app-skeleton-grafica />}
              </div>
            }
          </div>

          <!-- TARJETA 2: Límites (sin cambios) -->
          <div class="tarjeta w3-white " style="width: 51%; margin-left: 1vh;">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-setenta">
                <span class="w3-margin-left-contenido">{{
                  'liquidez.mayores.titulotab2'| translate }}
                </span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
              </div>
              <div class="w3-rest w3-right ">
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuTabla3">
                  more_vert
                </mat-icon>
                <mat-divider/>
                <mat-menu #menuTabla3="matMenu">
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportLim();">
                    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="tabla2 w3-scroll">
              @if (dataLim.length != 0) {
                <table class="w3-table borderInf">
                  <thead>
                    <tr class="w3-center">
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="width: 130px;">{{'liquidez.mayores.enc1'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="line-height: 1.2;">{{'liquidez.mayores.enc12'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="line-height: 1.2;">{{'liquidez.mayores.enc13'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" style="line-height: 1.2;">{{'liquidez.mayores.enc14'| translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        <span>Monto más alto de captaciones a la vista</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum(dataLim[0].saldo, false)}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum(dataLim[0].valor, false)}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum((dataLim[0].porcen*100).toFixed(1), true)}}%</span>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        <span>Monto más alto de depósitos a plazos</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum(dataLim[1].saldo, false)}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum(dataLim[1].valor, false)}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{formatoNum((dataLim[1].porcen*100).toFixed(1), true)}}%</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              }@else{<app-skeleton-table [columnas]="4" [filas]="4"/>}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- ========== ZONA GRÁFICA - GRÁFICA 2 (Mayores Depositantes) ========== -->
    <div class="zonaGraf w3-white " id="grafCont">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-setenta">
          <span class="w3-margin-left-contenido">
            {{encNum}} {{'liquidez.mayores.tituloGraf'| translate }}
          </span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
        </div>
        <div class="w3-rest w3-right ">
          @if (!tabMay) {
            <mat-icon fontSet="material-icons-outlined" class="w3-button iconoMen margenDer" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas2= !etiquetas2" matTooltip="{{'graf.desactivar'|translate}}">
              {{etiquetas2 ? 'label_off' : 'label'}}
            </mat-icon>
            <mat-icon  class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf('may')">
              zoom_out_map
            </mat-icon>
          }
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuGraf">
            more_vert
          </mat-icon>
          <mat-menu #menuGraf="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="Deudores">
              <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
              <span>No. Depositantes</span>
            </button>
            <button  class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
              <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
            </button>
            @if (!tabMay) {
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item (click)="grafica('', hori, encNum, true)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
              </button>
              <mat-divider/>
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica2()">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            } @else {
              <mat-divider/>
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportMayoresDepo()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            }
          </mat-menu>
          <mat-menu #Deudores="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 10}" [disabled]="encNum === 10" (click)="grafica(tipoGraf, hori, 10, tabMay)">
              <span>10</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 20}" [disabled]="encNum === 20" (click)="grafica(tipoGraf, hori, 20, tabMay)">
              <span>20</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 30}" [disabled]="encNum === 30" (click)="grafica(tipoGraf, hori, 30, tabMay)">
              <span>30</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 50}" [disabled]="encNum === 50" (click)="grafica(tipoGraf, hori, 50, tabMay)">
              <span>50</span>
            </button>
            @if (tabMay) {
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 100}" [disabled]="encNum === 100" (click)="grafica(tipoGraf, hori, 100, tabMay)">
              <span>100</span>
            </button>
            }
          </mat-menu>
          <mat-menu #tipoGrafica="matMenu"> 
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar' && hori}" [disabled]="tipoGraf === 'bar' && hori" (click)="grafica('bar', true, encNum, false)">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'liquidez.mayores.tipo1'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar' && !hori}" [disabled]="tipoGraf === 'bar' && !hori" (click)="grafica('bar', false, encNum, false)">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'liquidez.mayores.tipo2'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'area'}" [disabled]="tipoGraf === 'area'" (click)="grafica('area', false, encNum, false)">
              <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
              <span>{{'liquidez.mayores.tipo4'|translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      @if (!tabMay) {
        <div class="grafica">
          @if (dataGrafica2.length > 0 && labelsGrafica2.length > 0) {
            <app-graficador
              #graficador2
              [data]="dataGrafica2"
              [labels]="labelsGrafica2"
              [type]="tipoGrafica2"
              [colors]="colorMulti"
              [axisY]="ejesYGrafica2"
              [axisX]="ejesXGrafica2"
              [zona]="2"
              [etiquetas]="etiquetas2"
              [legend]="{enabled: false, position: 'bottom'}">
            </app-graficador>
          }@else {<app-skeleton-grafica />}
        </div>
      }@else {
        <div class="tabla3 w3-scroll">
          <table class="w3-table borderInf">
            <thead>
              <tr>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'liquidez.mayores.tit3'| translate }}</th>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'liquidez.mayores.tit4'| translate }}</th>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'liquidez.mayores.tit5'| translate }}</th>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'liquidez.mayores.tit6'| translate }}</th>
              </tr>
            </thead>
            @for (i of datosGrafTab; track i.numeroSocio; let j = $index) {
                <tr class="w3-table-trtd borderInfLow">
                  <td class="alinCenter borderAllLow">
                    <span>{{j+1}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{i.numeroSocio}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{formatoNum(i.cuentaAhorro, false)}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{formatoNum(i.saldoGestionTotal, false)}}</span>
                  </td>
                </tr>
            }
          </table>
        </div>
      }
    </div>    
  </div>
</app-esqueleto-tableros>

<!-- ========== MODAL AMPLIAR GRÁFICA ========== -->
 <app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">
              @if (tituloModal == 'prin') {{{'liquidez.mayores.tituloTabla'| translate}}}
              @else if (tituloModal == 'may') {{{encNum}} {{'liquidez.mayores.tituloGraf'| translate}}}
              @else if (tituloModal == 'pv') {{{'liquidez.mayores.titulotab1'| translate}}} 
            </span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ escrituraPeriodo(subTitles) }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
       <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (tituloModal === 'prin') {
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas1 = !etiquetas1" matTooltip="{{'graf.desactivar'|translate}}">
              {{etiquetas1 ? 'label_off' : 'label'}}
            </mat-icon>            
          }
          @if (tituloModal === 'may') {
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas2= !etiquetas2" matTooltip="{{'graf.desactivar'|translate}}">
              {{etiquetas2 ? 'label_off' : 'label'}}
            </mat-icon>
          }
          @if (tituloModal === 'pv') {
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="etiquetas3= !etiquetas3" matTooltip="{{'graf.desactivar'|translate}}">
              {{etiquetas3 ? 'label_off' : 'label'}}
            </mat-icon>
          }
          <mat-divider/>
          <mat-icon class="w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          (click)="exportarGraficaModal()" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body style="height: 60vh;">
    <!-- area grafica -->
    <div style="width: 100%;">
      <div class="w3-row" style="height: 58vh;">
        <!-- Gráfica Principal Ampliada -->
        @if (tituloModal === 'prin' && dataGrafica1.length > 0 && labelsGrafica1.length > 0) {
          <app-graficador
            [data]="dataGrafica1"
            [labels]="labelsGrafica1"
            [type]="tipoGrafica1"
            [colors]="colorMono"
            [axisY]="ejesYGrafica1"
            [axisX]="''"
            [zona]="4"
            [etiquetas]="etiquetas1"
            [legend]="{enabled: false, position: 'bottom'}">
          </app-graficador>
        }
        <!-- Gráfica Mayores Depositantes Ampliada -->
        @if (tituloModal === 'may' && dataGrafica2.length > 0 && labelsGrafica2.length > 0) {
          <app-graficador
            [data]="dataGrafica2"
            [labels]="labelsGrafica2"
            [type]="tipoGrafica2"
            [colors]="colorMulti"
            [axisY]="ejesYGrafica2"
            [axisX]="'Núm. socio'"
            [zona]="5"
            [etiquetas]="etiquetas2"
            [legend]="{enabled: false, position: 'bottom'}">
          </app-graficador>
        }
        <!-- Gráfica Proporción Variables Ampliada -->
        @if (tituloModal === 'pv' && dataGrafica3.length > 0 && labelsGrafica3.length > 0) {
          <app-graficador
            [data]="dataGrafica3"
            [labels]="labelsGrafica3"
            [type]="tipoGrafica3"
            [colors]="colorMulti"
            [axisY]="ejesYGrafica3"
            [axisX]="''"
            [zona]="6"
            [etiquetas]="etiquetas3"
            [legend]="{enabled: true, position: 'bottom'}">
          </app-graficador>
        }
      </div>
    </div>
  </div>
 </app-modal>